module.exports = __webpack_public_path__ + "static/media/like.0f9d0afb.png";